/**
 * Journalisation d'observabilité minimale (Sprint 0).
 * Sera remplacée au Sprint 1 par l'envoi vers le Worker (Workers Analytics Engine).
 */

type Level = 'debug' | 'info' | 'warn' | 'error';

function emit(level: Level, event: string, context?: Record<string, unknown>) {
  const entry = { ts: new Date().toISOString(), level, event, ...context };
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console[level === 'debug' ? 'log' : level](`[nexacraft:${event}]`, entry);
  }
}

export const logger = {
  debug: (event: string, ctx?: Record<string, unknown>) => emit('debug', event, ctx),
  info: (event: string, ctx?: Record<string, unknown>) => emit('info', event, ctx),
  warn: (event: string, ctx?: Record<string, unknown>) => emit('warn', event, ctx),
  error: (event: string, ctx?: Record<string, unknown>) => emit('error', event, ctx),
};
